/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMicIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-mic"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 14.5Q12 14.5 11.26 14.5Q10.53 14.5 9.49 13.46Q8.45 12.43 8.45 10.95L8.45 4.9Q8.45 3.42 9.49 2.39Q10.53 1.35 12 1.35Q13.47 1.35 14.51 2.39Q15.55 3.42 15.55 4.9L15.55 10.95Q15.55 12.43 14.51 13.46Q13.47 14.5 12 14.5ZM10.65 20.52L10.65 18.85Q8.07 18.5 6.28 16.69Q4.47 14.88 4.05 12.3Q3.95 11.78 4.33 11.36Q4.7 10.95 5.28 10.95Q5.83 10.95 6.24 11.34Q6.65 11.72 6.78 12.28Q7.22 14.07 8.69 15.19Q10.15 16.3 12 16.3Q13.85 16.3 15.31 15.19Q16.77 14.07 17.23 12.28Q17.38 11.72 17.77 11.34Q18.18 10.95 18.73 10.95Q19.3 10.95 19.68 11.35Q20.05 11.75 19.95 12.3Q19.52 14.85 17.71 16.68Q15.9 18.5 13.3 18.85L13.3 20.52Q13.3 21.07 12.91 21.46Q12.53 21.85 11.97 21.85Q11.43 21.85 11.04 21.46Q10.65 21.07 10.65 20.52Z" fill={color} />
    </svg>
  );
}
